// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invitations_header__eCfBG {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.invitations_title__XiZp7 {
  display: flex;
  gap: 4px;
  align-items: center;
}

.invitations_wrapper__Tu\\+XR {
  padding: 24px;
  background-color: var(--primary-background-color);
  border-radius: 6px;
  height: min-content;
}

.invitations_card__dJO6a {
  border-radius: 6px;
  background-color: var(--white-text-color);
  min-width: 500px;
}

.invitations_card-header__Jgz\\+j {
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 12px;
  border-bottom: 1px solid var(--primary-border-color);
}

.invitations_card-content__pku3e {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
}

.invitations_email-input__dbvcm {
  border: none !important;
  background-color: var(--primary-background-color);
}

.invitations_emails__yxIBb {
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 4px;
}

.invitations_email-subtitle__2DC4\\+ {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 4px;
}

.invitations_invitation-mails__RNQig {
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 12px;
}

.invitations_invite-title__QXyjU {
  display: flex;
  gap: 8px;
  align-items: center;
}

.invitations_invitation-list__n3Goj {
  display: grid;
  gap: 12px;
}

.invitations_invitations__RMq0M {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
}

.invitations_invitation-mail-card__Wo-cy {
  padding: 24px;
  background-color: var(--white-text-color);
  border-radius: 4px;
  display: grid;
  grid-template-rows: repeat(5, min-content);
  gap: 12px;
}

.invitations_link__GD88o {
  max-width: 245px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.invitations_magic-links-container__M\\+WHr {
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 24px;
  width: inherit;
}

.invitations_links-header__mmRtx {
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 12px;
}

.invitations_links-container__hnj\\+q {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.invitations_links-container-no-captain__7CP7x {
  display: grid;
  grid-template-columns: 1fr;
}

.invitations_links-disclaimer__jnEKd {
  background-color: var(--light-blue-background-color);
  padding: 12px;
  border-radius: 4px;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: center;
}

.invitations_link-card__oWQGA {
  background-color: var(--primary-background-color);
  padding: 12px;
  border-radius: 4px;
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 12px;
  cursor: pointer;

  & p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.invitations_link-card-header__L2ysO {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
}

.invitations_bold__GHxxV {
  font-weight: 800;
  color: var(--start-actions-color);
}

.invitations_icon__hozYk {
  color: var(--start-actions-color);
}

.invitations_player-color__ySgw9 {
  color: var(--error-text-color);
}

.invitations_captain-color__o6NzZ {
  color: var(--start-actions-color);
}

@media (max-width: 1368px) {
  .invitations_card__dJO6a {
    min-width: 400px;
  }
}

@media (max-width: 980px) {
  .invitations_card__dJO6a {
    min-width: 150px;
  }

  .invitations_invitations__RMq0M {
    grid-template-columns: 1fr;
  }

  .invitations_links-container__hnj\\+q {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/invitations/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;EACpD,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,eAAe;;EAEf;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.title {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.wrapper {\n  padding: 24px;\n  background-color: var(--primary-background-color);\n  border-radius: 6px;\n  height: min-content;\n}\n\n.card {\n  border-radius: 6px;\n  background-color: var(--white-text-color);\n  min-width: 500px;\n}\n\n.card-header {\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n  gap: 12px;\n  border-bottom: 1px solid var(--primary-border-color);\n}\n\n.card-content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 24px;\n}\n\n.email-input {\n  border: none !important;\n  background-color: var(--primary-background-color);\n}\n\n.emails {\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 4px;\n}\n\n.email-subtitle {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  gap: 4px;\n}\n\n.invitation-mails {\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 12px;\n}\n\n.invite-title {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.invitation-list {\n  display: grid;\n  gap: 12px;\n}\n\n.invitations {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 32px;\n}\n\n.invitation-mail-card {\n  padding: 24px;\n  background-color: var(--white-text-color);\n  border-radius: 4px;\n  display: grid;\n  grid-template-rows: repeat(5, min-content);\n  gap: 12px;\n}\n\n.link {\n  max-width: 245px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.magic-links-container {\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 24px;\n  width: inherit;\n}\n\n.links-header {\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 12px;\n}\n\n.links-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.links-container-no-captain {\n  display: grid;\n  grid-template-columns: 1fr;\n}\n\n.links-disclaimer {\n  background-color: var(--light-blue-background-color);\n  padding: 12px;\n  border-radius: 4px;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 12px;\n  align-items: center;\n}\n\n.link-card {\n  background-color: var(--primary-background-color);\n  padding: 12px;\n  border-radius: 4px;\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 12px;\n  cursor: pointer;\n\n  & p {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.link-card-header {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 12px;\n  align-items: center;\n}\n\n.bold {\n  font-weight: 800;\n  color: var(--start-actions-color);\n}\n\n.icon {\n  color: var(--start-actions-color);\n}\n\n.player-color {\n  color: var(--error-text-color);\n}\n\n.captain-color {\n  color: var(--start-actions-color);\n}\n\n@media (max-width: 1368px) {\n  .card {\n    min-width: 400px;\n  }\n}\n\n@media (max-width: 980px) {\n  .card {\n    min-width: 150px;\n  }\n\n  .invitations {\n    grid-template-columns: 1fr;\n  }\n\n  .links-container {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `invitations_header__eCfBG`,
	"title": `invitations_title__XiZp7`,
	"wrapper": `invitations_wrapper__Tu+XR`,
	"card": `invitations_card__dJO6a`,
	"card-header": `invitations_card-header__Jgz+j`,
	"card-content": `invitations_card-content__pku3e`,
	"email-input": `invitations_email-input__dbvcm`,
	"emails": `invitations_emails__yxIBb`,
	"email-subtitle": `invitations_email-subtitle__2DC4+`,
	"invitation-mails": `invitations_invitation-mails__RNQig`,
	"invite-title": `invitations_invite-title__QXyjU`,
	"invitation-list": `invitations_invitation-list__n3Goj`,
	"invitations": `invitations_invitations__RMq0M`,
	"invitation-mail-card": `invitations_invitation-mail-card__Wo-cy`,
	"link": `invitations_link__GD88o`,
	"magic-links-container": `invitations_magic-links-container__M+WHr`,
	"links-header": `invitations_links-header__mmRtx`,
	"links-container": `invitations_links-container__hnj+q`,
	"links-container-no-captain": `invitations_links-container-no-captain__7CP7x`,
	"links-disclaimer": `invitations_links-disclaimer__jnEKd`,
	"link-card": `invitations_link-card__oWQGA`,
	"link-card-header": `invitations_link-card-header__L2ysO`,
	"bold": `invitations_bold__GHxxV`,
	"icon": `invitations_icon__hozYk`,
	"player-color": `invitations_player-color__ySgw9`,
	"captain-color": `invitations_captain-color__o6NzZ`
};
export default ___CSS_LOADER_EXPORT___;
